import script from "./MostaContextMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./MostaContextMenu.vue?vue&type=script&setup=true&lang=ts"

import "./MostaContextMenu.vue?vue&type=style&index=0&id=b1c9b226&lang=scss"

const __exports__ = script;

export default __exports__